<div class="file-upload">
  <input
    #fileInput
    class="file-upload__input"
    type="file"
    [id]="inputId"
    [accept]="accept"
    [disabled]="disabled"
    (change)="onFileSelected($event)">

  <label
    class="file-upload__dropzone"
    [class.is-dragging]="isDragging()"
    [for]="inputId"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
    <span class="file-upload__icon" aria-hidden="true">
      <i class="bi bi-upload"></i>
    </span>
    <span class="file-upload__copy">
      @if (selectedFileName()) {
        <span class="file-upload__title" [title]="selectedFileName()">{{ selectedFileName() }}</span>
      } @else {
        <span class="file-upload__title">{{ prompt }}</span>
      }
      <span class="file-upload__hint">{{ hint }}</span>
    </span>
    <span class="file-upload__button">Choose File</span>
  </label>
</div>
